import React from "react";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ConfirmDialog } from "src/apps/commons/dataDisplays";
import Form from "./CreateForm";
import { constants } from "../utils";
import { useCreate } from "../hooks";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    padding: "16px"
  }
}));

const FormContainers: React.FC<unknown> = _ => {
  const classes = useStyles();

  const { saving, confirmDialogState, handleSave, handleCloseDialog } =
    useCreate();

  return (
    <Paper className={classes.root}>
      <Form isSaving={saving} onSubmit={handleSave} />

      <ConfirmDialog
        title={`ยืนยันการสร้าง${constants.label}?`}
        open={confirmDialogState.open}
        onClose={handleCloseDialog}
        onConfirm={confirmDialogState.onConfirm}
      />
    </Paper>
  );
};

export default FormContainers;
